import { NumberUtils } from "neo-common";
import {Languages} from "../../../Utils/Languages";
import {BetManager} from "../../../Managers/BetManager";
import {DataManager} from "../../../Managers/DataManager";
import {GameData} from "../Datas/GameData";
import {FreeRoundBonus} from "../Bonuses/FreeRoundBonus";

export class AutoplayConfirmationDialog {
    private static _opened: boolean = false;
    private static _id = "autoplayConfirmationDialog";

    static openDialog(count: number, callback: () => void): void {
        if (FreeRoundBonus.inFrb) {
            callback();
            return;
        }

        if (isNaN(count)) {
            callback();
            return;
        }

        const dialog = document.getElementById(AutoplayConfirmationDialog._id);

        if (dialog) {
            AutoplayConfirmationDialog.updateDialogText(count);
            AutoplayConfirmationDialog.updateDialogCallback(callback);

            dialog.classList.remove('_disabled');
            this._opened = true;
        }
    }

    static closeDialog(): void {
        if (!this._opened) {
            return;
        }

        const dialog = document.getElementById(AutoplayConfirmationDialog._id);
        if (dialog) {
            dialog.classList.add('_disabled');
            this._opened = false;
        }
    }

    protected static updateDialogText(count: number): void {
        const text = document.getElementById("autoplayConfirmationText");
        const bet = Languages.formatText(Languages.FormatMoney, BetManager.Bet.toString()) +
            " " + DataManager.getDataById(GameData.DataCurrency);
        const total = Languages.formatText(Languages.FormatMoney, NumberUtils.multiply(count, BetManager.Bet)) +
            " " + DataManager.getDataById(GameData.DataCurrency);

        text.innerHTML = Languages.getRid("AUTOPLAY_CONFIRMATION_TEXT", count.toString(), bet, total);
    }

    protected static updateDialogCallback(callback: () => void): void {
        const continueBtn = document.getElementById("autoplayConfirmationContinueButton");

        if (continueBtn) {
            continueBtn.onclick = () => {
                AutoplayConfirmationDialog.closeDialog();
                callback();
            };
        }

        const cancelBtn = document.getElementById("autoplayConfirmationCancelButton");

        if (cancelBtn) {
            cancelBtn.onclick = () => {
                AutoplayConfirmationDialog.closeDialog();
            };
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Dialogs/AutoplayConfirmationDialog.ts
 **/